import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../utils/axios";
import { API_ROUTES } from "./routes";
import { showToast } from "../components/ui/toast";

export const useGetOrganizationsQuery = () => {
  const { data, isPending, isError, error } = useQuery({
    queryKey: [API_ROUTES.GET_ORGANIZATIONS],
    queryFn: () => api.get(API_ROUTES.GET_ORGANIZATIONS),
  });

  return { data: data?.data?.data ?? [], isPending, isError, error };
};

export const useGetOrganizationByIdQuery = (id) => {
  const { data, isPending, isError, error } = useQuery({
    queryKey: [API_ROUTES.GET_ORGANIZATIONS, id],
    queryFn: () =>
      api.get(`${API_ROUTES.GET_ORGANIZATIONS}/${id}`),
    enabled: !!id,
  });

  return { data: data?.data?.data ?? null, isPending, isError, error };
};

export const useCreateOrganizationMutation = () => {
  const queryClient = useQueryClient();
  const { mutate, isError, error, isLoading, isSuccess, isPending } =
    useMutation({
      mutationFn: (data) => api.post(API_ROUTES.GET_ORGANIZATIONS, data),
      onSuccess: () => {
        showToast("success", "Organization created successfully");
      },
      onSettled: () => {
        queryClient.invalidateQueries({
          queryKey: [API_ROUTES.GET_ORGANIZATIONS],
        });
      },
    });

  return { mutate, isError, error, isLoading, isSuccess, isPending };
};

export const useUpdateOrganizationMutation = () => {
  const queryClient = useQueryClient();
  const { mutate, isError, error, isLoading, isSuccess, isPending } =
    useMutation({
      mutationFn: ({ id, ...data }) =>
        api.put(`${API_ROUTES.GET_ORGANIZATIONS}/${id}`, data),
      onSuccess: () => {
        showToast("success", "Organization updated successfully");
      },
      onSettled: (_, __, variables) => {
        queryClient.invalidateQueries({
          queryKey: [API_ROUTES.GET_ORGANIZATIONS],
        });
        if (variables?.id) {
          queryClient.invalidateQueries({
            queryKey: [API_ROUTES.GET_ORGANIZATIONS, variables.id],
          });
        }
      },
    });

  return { mutate, isError, error, isLoading, isSuccess, isPending };
};

export const useDeleteOrganizationMutation = () => {
  const queryClient = useQueryClient();
  const { mutate, isError, error, isLoading, isSuccess, isPending } =
    useMutation({
      mutationFn: (id) =>
        api.delete(`${API_ROUTES.GET_ORGANIZATIONS}/${id}`),
      onSuccess: () => {
        showToast("success", "Organization deleted successfully");
      },
      onSettled: () => {
        queryClient.invalidateQueries({
          queryKey: [API_ROUTES.GET_ORGANIZATIONS],
        });
      },
    });

  return { mutate, isError, error, isLoading, isSuccess, isPending };
};